/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2021 Tableau.com
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function($) {

  // Throttle variables
  var $scroll_timeout;
  var $throttle = 50;

  // In view variables
  var $animation_elements = $('.js-section-animation');
  var $window = $(window);

  // Parallax variables
  var parallax_element = $('.tc-feature-highlight:not(.tc-feature-highlight--no-parallax) .feature-highlight__image');
  var parallax1_quantity = parallax_element.length;

  // For on scroll animations
  function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);
    $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top + 500;
      var element_bottom_position = (element_top_position + element_height);
      //check to see if this current container is within viewport
      if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
        $element.addClass('in-view');
      }
    });
  }

  // Parallax images
  function parallax_image() {
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallax1_quantity; i++) {
        var current_element = parallax_element.eq(i),
          window_top = $(window).scrollTop(),
          elemen_top = current_element.offset().top,
          element_height = current_element.height(),
          viewport_height = window.innerHeight * 0.5 - element_height * 0.5,
          scrolled = window_top - elemen_top + viewport_height;

        // Only run parallax_image when viewport is 850px and wider
        if ( $(window).width() > 850 ) {
          current_element.css({
            transform: 'translate3d(0,' + scrolled * -0.15 + 'px, 0) scale(1.5)'
          });
        } else {
          current_element.css({
            transform: ''
          });
        }
      }
    });
  }

  // On scroll/resize run check_if_in_view and parallax_image
  $window.on('scroll resize', function () {
    if (!$scroll_timeout) {
      $scroll_timeout = setTimeout(function () {
        $scroll_timeout = null;
        check_if_in_view();
        parallax_image();
      }, $throttle);
    }
  });

})(jQuery);
